import axios, { AxiosError, AxiosResponse } from 'axios'
import { config } from '@/config'
import { formatResponse } from './helpers/formatResponse'
import type { DashboardDomainRegistryItem } from '@/types/DashboardDomainRegistry.types'

/**
 * DashboardDomainRegistryAPI — read-only fetch of the dashboard-era domain
 * registry. Backed by `GET /v1/dashboard-domains` (TDD
 * `plans/2026-05-06-tier-c-cleanup-tdd.md` §3.2.1).
 *
 * Wire shape: `{ domains: DashboardDomainRegistryItem[] }` — raw, NOT wrapped
 * in the legacy envelope (matches `DashboardFiltersAPI` in
 * `DashboardFilters.ts`). Per CEO 2026-04-28 directive, new endpoints bypass
 * the `{ success, data, messages }` `TCSAPIResponse` envelope.
 */
export const DashboardDomainRegistryAPI = {
  list: async (
    token: string,
  ): Promise<{
    data: { domains: DashboardDomainRegistryItem[] } | undefined
    err: string | undefined
    status: number | undefined
  }> => {
    try {
      const resp: AxiosResponse<{ domains: DashboardDomainRegistryItem[] }> =
        await axios({
          method: 'GET',
          url: `${config.apiUrl}/v1/dashboard-domains`,
          headers: { Authorization: `Bearer ${token}` },
        })
      return { data: resp.data, err: undefined, status: resp.status }
    } catch (error) {
      const axiosErr = error as AxiosError
      const formatted = formatResponse<{
        domains: DashboardDomainRegistryItem[]
      }>(null, axiosErr)
      return {
        data: formatted.data,
        err: formatted.err,
        status: axiosErr.response?.status,
      }
    }
  },
}
